import { asyncRouterMap, constantRouterMap } from '@/router/index';
import { fetchAnnualJobList } from '@/api/menu';

const annualComponentMap = {
  reportIndex: () => import('@/views/files/reportIndex'),
  modularAnnualTaskPage: () => import('@/views/modularPage/annualTaskPage'),
  modularAnnualStatisticPage: () => import('@/views/modularPage/statisticPage')
};

function normalizeComponentName(component) {
  if (!component) return '';
  return String(component).replace(/^["']|["']$/g, '');
}

function parseAnnualRoute(menu) {
  if (!menu || !menu.meta) return null;
  try {
    const routeConfig = typeof menu.meta === 'string' ? JSON.parse(menu.meta) : menu.meta;
    const componentName = normalizeComponentName(routeConfig.component);
    const component = annualComponentMap[componentName];
    if (!component) return null;
    return {
      path: routeConfig.path || menu.name,
      name: routeConfig.name || menu.name,
      component: component,
      meta: routeConfig.meta || { title: menu.pageName, icon: 'product-list' },
      props: routeConfig.props || { routeName: menu.name },
      hidden: routeConfig.hidden === true,
      sort: menu.sort || 0
    };
  } catch (e) {
    return null;
  }
}

function appendAnnualRoutes(routes, annualMenus) {
  if (!annualMenus || annualMenus.length === 0) return;
  annualMenus.forEach(menu => {
    const parentName = menu.parentName || 'activity';
    const parentRoute = routes.find(route => route.name === parentName);
    const route = parseAnnualRoute(menu);
    if (!parentRoute || !route) return;
    parentRoute.children = parentRoute.children || [];
    const exists = parentRoute.children.some(child => child.name === route.name);
    if (!exists) {
      parentRoute.children.push(route);
    }
  });
}

const landlordForceHiddenRoutes = ['landlordTaskFill', 'landlordRoomTaskFill'];

//判断是否有权限访问该菜单
function hasPermission(menus, route, roles) {
  if (route.name) {
    if (landlordForceHiddenRoutes.includes(route.name)) {
      route.hidden = true;
      route.sort = -1;
      return true;
    }

    let currMenu = getMenu(route.name, menus);
    if (currMenu != null) {
      route.meta = route.meta || {};
      if (currMenu.title != null && currMenu.title !== '') {
        route.meta.title = currMenu.title;
      }
      if (currMenu.icon != null && currMenu.icon !== '') {
        route.meta.icon = currMenu.icon;
      }
      if (currMenu.hidden != null) {
        route.hidden = currMenu.hidden !== 0;
      }
      if (currMenu.sort != null && currMenu.sort !== '') {
        route.sort = currMenu.sort;
      }
      return true;
    } else {
      route.sort = 0;
      if (route.hidden !== undefined && route.hidden === true) {
        route.sort = -1;
        return true;
      } else {
        if (route.children && route.children.length > 0 && route.component && !route.component.name) {
          return true;
        }
        return false;
      }
    }
  } else {
    return true;
  }
}

function getMenu(name, menus) {
  for (let i = 0; i < menus.length; i++) {
    let menu = menus[i];
    if (name === menu.name) {
      return menu;
    }
    if (menu.children && menu.children.length > 0) {
      let found = getMenu(name, menu.children);
      if (found) {
        return found;
      }
    }
  }
  return null;
}

function sortRouters(accessedRouters) {
  for (let i = 0; i < accessedRouters.length; i++) {
    let router = accessedRouters[i];
    if (router.children && router.children.length > 0) {
      router.children.sort(compare('sort'));
    }
  }
  accessedRouters.sort(compare('sort'));
}

function cloneRoutes(routes) {
  return routes.map(route => {
    const cloned = Object.assign({}, route)
    if (route.meta) {
      cloned.meta = Object.assign({}, route.meta)
    }
    if (route.props && typeof route.props === 'object') {
      cloned.props = Object.assign({}, route.props)
    }
    if (route.children) {
      cloned.children = cloneRoutes(route.children)
    }
    return cloned
  })
}

//降序比较函数
function compare(p) {
  return function(m, n) {
    let a = m[p];
    let b = n[p];
    return b - a;
  };
}

function countRoutes(routers) {
  let count = 0;
  routers.forEach(router => {
    if (!router.hidden) {
      count++;
      if (router.children && router.children.length > 0) {
        count += countRoutes(router.children);
      }
    }
  });
  return count;
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    permissionPageCount: 0
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    },
    SET_PERMISSION_PAGE_COUNT: (state, count) => {
      state.permissionPageCount = count;
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { menus, roles } = data;

        function filterRoutes(routes, menus, roles) {
          return routes.filter(route => {
            if (hasPermission(menus, route, roles)) {
              if (route.children && route.children.length > 0) {
                route.children = filterRoutes(route.children, menus, roles);
                if (route.children.length === 0) {
                  return false;
                }
              }
              return true;
            }
            return false;
          });
        }

        function finish(annualMenus) {
          const routes = cloneRoutes(asyncRouterMap);
          appendAnnualRoutes(routes, annualMenus);
          const accessedRouters = filterRoutes(routes, menus, roles);
          sortRouters(accessedRouters);
          commit('SET_ROUTERS', accessedRouters);
          const pageCount = countRoutes(accessedRouters);
          commit('SET_PERMISSION_PAGE_COUNT', pageCount);
          const navType = pageCount <= 5 ? 'top' : 'side';
          commit('SET_NAV_TYPE', navType, { root: true });
          resolve(accessedRouters);
        }

        fetchAnnualJobList().then(response => {
          finish(response.data || []);
        }).catch(() => {
          finish([]);
        });
      });
    }
  }
};

export default permission;



// WEBPACK FOOTER //
// ./src/store/modules/permission.js